import React from "react";
import {css, useTheme} from "@emotion/react";

import {calculateRemSize, flex, pr} from "@pg-design/helpers-css";
import {BellIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    className?: string;
}

export const OfferChatBotHeader = (props: IProps) => {
    const theme = useTheme();

    return (
        <div css={headerWrapperStyle} className={props.className}>
            <div css={iconWrapperStyle}>
                <BellIcon size="4.8" fill={theme.colors.secondary} />
            </div>
            <Text as="div" variant="headline_6" css={[pr(2)]}>
                Bądź na bieżąco! Zapisz się na powiadomienia
            </Text>
        </div>
    );
};

const headerWrapperStyle = css`
    ${flex("center", "flex-start")};
    flex-direction: row;
    gap: ${calculateRemSize(2)};
`;

const iconWrapperStyle = css`
    width: 4.8rem;
    height: 4.8rem;
    ${flex("center", "center")};
    flex: 0 0 auto;
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {calculateRemSize, flex, pr} from "@pg-design/helpers-css";
import {BellIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    className?: string;
}

export const OfferChatBotHeader = (props: IProps) => {
    const theme = useTheme();

    return (
        <div css={headerWrapperStyle} className={props.className}>
            <div css={iconWrapperStyle}>
                <BellIcon size="4.8" fill={theme.colors.secondary} />
            </div>
            <Text as="div" variant="headline_6" css={[pr(2)]}>
                Bądź na bieżąco! Zapisz się na powiadomienia
            </Text>
        </div>
    );
};

const headerWrapperStyle = css`
    ${flex("center", "flex-start")};
    flex-direction: row;
    gap: ${calculateRemSize(2)};
`;

const iconWrapperStyle = css`
    width: 4.8rem;
    height: 4.8rem;
    ${flex("center", "center")};
    flex: 0 0 auto;
`;
